import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";
import CameraswitchIcon from "@mui/icons-material/Cameraswitch";
import CameraIco from "../../assets/svgs/photo-camera.svg";

const WebcamCapture = (props: any) => {
  const { handleSetImage } = props;
  const webcamRef = useRef<any>(null);
  // Car wash photos are of the location, not the RM/admin taking them —
  // default to the back ("environment") camera. `ideal` (not `exact`) so
  // desktops/webcams without a back camera still fall back gracefully.
  const [facingMode, setFacingMode] = useState<"environment" | "user">(
    "environment"
  );

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: { ideal: facingMode },
  };

  const capture = useCallback(
    (e?: React.MouseEvent<HTMLButtonElement>) => {
      // Prevent the click from bubbling into the surrounding <form> as a
      // native submit (this component is rendered inside the Add Car Wash
      // modal's <form>).
      e?.preventDefault();
      const imageSrc = webcamRef.current?.getScreenshot();
      // getScreenshot() returns null when the video element is not yet ready
      // (e.g. rapid overlay re-open). Guard so a null value never propagates
      // into image processing.
      if (!imageSrc) return;
      handleSetImage(imageSrc);
    },
    [handleSetImage]
  );

  const flipCamera = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();
    setFacingMode((prev) => (prev === "environment" ? "user" : "environment"));
  };

  return (
    <div className="flex flex-col justify-center items-center fixed top-0 left-0 w-full h-full bg-slate-800 bg-opacity-70 p-4 overflow-auto">
      <Webcam
        // Remount on facingMode change so the browser re-requests
        // getUserMedia with the new constraint instead of keeping the old
        // stream bound.
        key={facingMode}
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        minScreenshotWidth={180}
        minScreenshotHeight={180}
        className="max-w-full max-h-[75vh] w-auto h-auto object-contain rounded-lg"
      />
      <div className="flex items-center gap-4 mt-8">
        <button
          type="button"
          className="p-4 rounded-lg text-sm text-white border bg-white bg-opacity-50 border-blue-900"
          onClick={flipCamera}
          title="Switch camera"
        >
          <CameraswitchIcon style={{ width: 18, height: 18 }} />
        </button>
        <button
          type="button"
          className="p-4 rounded-lg text-sm text-white border bg-white bg-opacity-50 border-blue-900"
          onClick={capture}
        >
          <img width={18} height={18} src={CameraIco} alt="upload_hover" />
        </button>
      </div>
    </div>
  );
};

export default WebcamCapture;
